import {
    Component, Input,Output, ElementRef, AfterViewInit, ViewChild,EventEmitter
  } from '@angular/core';  
  import { fromEvent } from 'rxjs';
  import { switchMap, takeUntil, pairwise } from 'rxjs/operators'
import { WindowScrollController } from '@fullcalendar/angular';

  @Component({
    selector: 'app-canvas',
    template: '<canvas id="can" (click)="getIndex(canvasIndex)" (touchstart)="getIndexForTouch(canvasIndex,$event)" class="upper-canvas FormResizer" style="z-index:5;position: absolute;left: 0px; top: 0px; touch-action: none; user-select: none; cursor: crosshair;" #canvas></canvas>',
    styles: ['canvas { border: 1px solid #000; }']
  })
  export class CanvasComponent implements AfterViewInit {
  
    @ViewChild('canvas') public canvas: ElementRef;
  
    @Input() public width = 1000;
    @Input() public height = 1200;
    @Input() public canvasIndex=0;

    @Output() newItemEvent = new EventEmitter<any>();
    @Output() drawnIndices = new EventEmitter<Array<any>>();     
    private cx: CanvasRenderingContext2D;
    
    indexDrawn:Array<any>=[];
     canvasEl: HTMLCanvasElement;
      ongoingTouches = [];
    public ngAfterViewInit() {
     this.canvasEl = this.canvas.nativeElement;
      this.cx = this.canvasEl.getContext('2d');
  
      this.canvasEl.width = this.width;
      this.canvasEl.height = this.height;
  
      this.cx.lineWidth = 3;
      this.cx.lineCap = 'round';
      this.cx.strokeStyle = '#000';

      // const rect = this.canvasEl.getBoundingClientRect();
      // var prevPos = {
      //  x:0,y:0
      // };
  
      //   this.canvasEl.addEventListener('touchStart',(e:TouchEvent)=>{
      //     prevPos = {
      //       x: e.touches[0].pageX -  this.canvasEl.offsetLeft,
      //       y: e.touches[0].pageY - this.canvasEl.offsetTop
      //     };
      //   },false);
  
      //   this.canvasEl.addEventListener('touchEnd',(e:TouchEvent)=>{
      //    const currentPos = {
      //       x: e.touches[0].pageX -  this.canvasEl.offsetLeft,
      //       y: e.touches[0].pageY - this.canvasEl.offsetTop
      //     };
      //     this.drawOnCanvasForTouch(prevPos, currentPos);
      //   },false);
  
      this.captureEvents(this.canvasEl);
    }
    
    handleStart(evt) {
      evt.preventDefault();      
      
      var touches = evt.changedTouches;
    
      for (var i = 0; i < touches.length; i++) {
       
        this.ongoingTouches.push(this.copyTouch(touches[i]));
       
        this.cx.beginPath();
        this.cx.arc(touches[i].clientX-10, touches[i].clientY-10, 4, 0, 2 * Math.PI, false);  // a circle at the start
       
        this.cx.fill();      
      }
    }

    handleMove(evt) {
      evt.preventDefault();
     
      var touches = evt.changedTouches;
    
      for (var i = 0; i < touches.length; i++) {
        
        var idx = this.ongoingTouchIndexById(touches[i].identifier);
    
        if (idx >= 0) {
         
          this.cx.beginPath();
        
          this.cx.moveTo(this.ongoingTouches[idx].pageX, this.ongoingTouches[idx].pageY);
        
          this.cx.lineTo(touches[i].pageX, touches[i].pageY);
        
          this.cx.stroke();
    
          this.ongoingTouches.splice(idx, 1,this.copyTouch(touches[i]));  // swap in the new touch record
          
        } else {
         
        }
      }
    }

    handleEnd(evt) {
      evt.preventDefault();
     
      var touches = evt.changedTouches;
    
      for (var i = 0; i < touches.length; i++) {
       
        var idx = this.ongoingTouchIndexById(touches[i].identifier);
    
        if (idx >= 0) {
        
          this.cx.beginPath();
          this.cx.moveTo(this.ongoingTouches[idx].pageX, this.ongoingTouches[idx].pageY);
          this.cx.lineTo(touches[i].pageX, touches[i].pageY);
          this.cx.fillRect(touches[i].pageX - 4, touches[i].pageY - 4, 8, 8);  // and a square at the end
          this.ongoingTouches.splice(idx, 1);  // remove it; we're done
        } else {
         
        }
      }
    }

    handleCancel(evt) {
      evt.preventDefault();
     
      var touches = evt.changedTouches;
    
      for (var i = 0; i < touches.length; i++) {
        var idx = this.ongoingTouchIndexById(touches[i].identifier);
        this.ongoingTouches.splice(idx, 1);  // remove it; we're done
      }
    }

    ongoingTouchIndexById(idToFind) {
      for (var i = 0; i < this.ongoingTouches.length; i++) {
        var id = this.ongoingTouches[i].identifier;
    
        if (id == idToFind) {
          return i;
        }
      }
      return -1;    // not found
    }

    copyTouch({ identifier, pageX, pageY }) {
      return { identifier, pageX, pageY };
    }

    getDrawIndices(){
      this.drawnIndices.emit(this.indexDrawn);
    }

    public getIndex(index:any){      
      this.indexDrawn.push({key:this.canvasIndex,canv:this.canvasEl});
      this.newItemEvent.emit(this.indexDrawn);
    }

    public getIndexForTouch(index:any,event:TouchEvent){      
      this.indexDrawn.push({key:this.canvasIndex,canv:this.canvasEl});
      this.newItemEvent.emit(this.indexDrawn);      
    }

    private captureEvents(canvasEl: HTMLCanvasElement) {


    //this will capture all mousedown events from the canvas element
    fromEvent(canvasEl, 'touchstart')
    .pipe(
      switchMap((e) => {
        // after a mouse down, we'll record all mouse moves
        return fromEvent(canvasEl, 'touchmove')
          .pipe(
            // we'll stop (and unsubscribe) once the user releases the mouse
            // this will trigger a 'mouseup' event    
            takeUntil(fromEvent(canvasEl, 'touchleave')),
            takeUntil(fromEvent(canvasEl, 'touchend')),
            // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
            takeUntil(fromEvent(canvasEl, 'touchcancel')),
            // pairwise lets us get the previous value to draw a line from
            // the previous point to the current point    
            pairwise()
          )
      })
    )
    .subscribe((res: [TouchEvent, TouchEvent]) => {
      const rect = canvasEl.getBoundingClientRect();
     
      // previous and current position with the offset
      var touch = res;

      let scaledval =Number( rect.width/canvasEl.offsetWidth);
      //for ipad pro landscape
      if((Number(scaledval.toFixed(2)) >= 0.90)){
        scaledval = Number (1.25* scaledval);
      }
      //for ipad
     
      if((Number(scaledval.toFixed(2)) >= 0.60)&&(Number(scaledval.toFixed(2)) < 0.79)){
        scaledval = Number (2.75* scaledval);
      }
      //for ipad pro
      if((Number(scaledval.toFixed(2)) >= 0.79)&&(Number(scaledval.toFixed(2)) < 0.90)){
        scaledval = Number (1.55* scaledval);
      }
    
      // for phone resolutions
      else if(Number(scaledval.toFixed(2)) <0.60){
        scaledval = Number (6.2 * scaledval);
      }
    
      //for ipad pro landscape
      let scaledHeight=Number( rect.height/canvasEl.offsetHeight);
      if((Number(scaledHeight.toFixed(2)) >= 0.90)){
        scaledHeight = Number (1.25* scaledHeight);
      }  
      //for ipad
      if((Number(scaledHeight.toFixed(2)) >= 0.60)&&(Number(scaledHeight.toFixed(2)) < 0.79)){
        scaledHeight = Number (2.75* scaledHeight);
      }
      //for ipad pro
      if((Number(scaledHeight.toFixed(2)) >= 0.79)&&(Number(scaledHeight.toFixed(2)) < 0.9)){
        scaledHeight = Number (1.55* scaledHeight);
      }    
       
      /// for phone resolutions
       else if(Number(scaledHeight.toFixed(2)) <0.60){      
        scaledHeight = Number (6.2 * scaledHeight);
      }
        var prevPos = {
          x: (scaledval)  * (res[0].touches[0].pageX - (rect.left))  ,
        y: scaledHeight * (res[0].touches[0].pageY - rect.top)
      };

      if(rect.bottom>=1200){
         prevPos = {
          x: res[0].touches[0].clientX -  rect.left  ,
          y: res[0].touches[0].clientY - rect.top
        };
      }
      res[0].preventDefault();
      res[0].stopImmediatePropagation();

     // this.cx.scale(scaledval,scaledHeight)
      var currentPos = {
        x: (scaledval)  * (res[1].touches[0].pageX - rect.left ),//+rect.left)   ,
        y: (scaledHeight)  * (res[1].touches[0].pageY - rect.top)
      };
      if(rect.bottom>=1200){
       // this.cx.scale(1,1)
         currentPos = {
          x: res[1].touches[0].clientX - rect.left,
          y: res[1].touches[0].clientY - rect.top
        };
      }
         
      res[1].preventDefault();
      res[1].stopImmediatePropagation();
      // this method we'll implement soon to do the actual drawing

     
      this.drawOnCanvasForTouch(prevPos, currentPos);
      
    });
   

      // this will capture all mousedown events from the canvas element
      fromEvent(canvasEl, 'mousedown')
        .pipe(
          switchMap((e) => {
            // after a mouse down, we'll record all mouse moves
            return fromEvent(canvasEl, 'mousemove')
              .pipe(
                // we'll stop (and unsubscribe) once the user releases the mouse
                // this will trigger a 'mouseup' event    
                takeUntil(fromEvent(canvasEl, 'mouseup')),
                // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
                takeUntil(fromEvent(canvasEl, 'mouseleave')),
                // pairwise lets us get the previous value to draw a line from
                // the previous point to the current point    
                pairwise()
              )
          })
        )
        .subscribe((res: [MouseEvent, MouseEvent]) => {
          const rect = canvasEl.getBoundingClientRect();
    
          // previous and current position with the offset
          const prevPos = {
            x: res[0].clientX - rect.left,
            y: res[0].clientY - rect.top
          };
    
          const currentPos = {
            x: res[1].clientX - rect.left,
            y: res[1].clientY - rect.top
          };
    
          // this method we'll implement soon to do the actual drawing
          this.drawOnCanvas(prevPos, currentPos);
         
        });

       
    }
  
    private drawOnCanvasForTouch(prevPos: { x: number, y: number }, currentPos: { x: number, y: number }) {
      if (!this.cx) { return; }
  
      this.cx.beginPath();
  
      if (prevPos) {
        this.cx.moveTo(prevPos.x  , prevPos.y); // from
        this.cx.lineTo(currentPos.x , currentPos.y);
       
        this.cx.stroke();
        
      }
    }


    private drawOnCanvas(prevPos: { x: number, y: number }, currentPos: { x: number, y: number }) {
      if (!this.cx) { return; }
  
      this.cx.beginPath();
  
      if (prevPos) {
        this.cx.moveTo(prevPos.x, prevPos.y); // from
        this.cx.lineTo(currentPos.x, currentPos.y);
        this.cx.stroke();
        
      }
    }
  
  }
  